import React, { useState } from 'react';
import "./Waitlist.css";
import addToWaitlist from '../../api/waitlist';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../../../utils/firebase';
import { ToastContainer, toast } from 'react-toastify';
import LoadingSpinner from '../../../utils/Spinner';

const Waitlist = ({setIsJoining}) => {

    const [fullName, setFullName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [country, setCountry] = useState("");
    const [sex, setSex] = useState("female");
    const [loading, setLoading] = useState(false);

    const submitWaitlist = async () => {
//   setIsJoining(true);
setLoading(true);

const notify = () => toast("You have been successfully registered");

  const res = await addToWaitlist({
    fullName,
    email,
    phone,
    sex,
    country,
  });



  if (res.success) {
    notify();
    setCountry("");
    setEmail("");
    setFullName("");
    setPhone("");
    setSex("female");
    setLoading(false);
  setIsJoining(false);
  }

};

  return (
    <div className='Waitlist'>
        <div className="display-flex-space" style={{width: "100%"}}>
            <div style={{color: "transparent"}}>.</div>
            <p>Early Registration</p>
            <div onClick={() => {console.log("clicked");setIsJoining(); }}>X</div>
        </div>
        <form className='waitlist-form'>
            <div className="form-group">
                <label htmlFor="fullName">FullName:</label>
                <input type="text" value={fullName} placeholder='Mary Phiri' name="fullName" id="fullName" onChange={(e) => {setFullName(e.target.value)}} />
            </div>
            <div className="form-group">
                <label htmlFor="email">Email Address:</label>
                <input type="email" value={email} placeholder='maryphiri@gmail.com' name="email" id="email" onChange={(e) => {setEmail(e.target.value)}} />
            </div>
            <div className="form-group">
                <label htmlFor="phone">Phone:</label>
                <input type="text" value={phone} placeholder='Include country code eg +260777555500' name="phone" id="phone" onChange={(e) => {setPhone(e.target.value)}} />
            </div>
            <div className="form-group">
                <label htmlFor="sex">Sex:</label>
                <select name="sex" id="sex" value={sex} onChange={(e) => {setSex(e.target.value)}}>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                </select>
            </div>
             <div className="form-group">
                <label htmlFor="country">Country:</label>
                <input type="text" value={country} placeholder='Zambia' name="country" id="country" onChange={(e) => {setCountry(e.target.value)}} />
            </div>

            <button type="button" onClick={submitWaitlist}>Register</button>
        </form>
        <ToastContainer />
        <LoadingSpinner loading={loading} />
    </div>
  )
}

export default Waitlist;